<template lang="pug">
  v-col
    v-subheader.mt-4 Utilisateur aléatoire
    utility-action-state(:action="changeRandomUser")
      template(#default="{ loading, trigger }")
        v-row(wrap)
          v-col(:cols="12")
            v-card(
              :disabled="loading"
              @click="() => $router.push({ name: `Profile`, params: { id: randomUser.id } })")
              v-card-text
                v-row.align-center(dense)
                  v-col.shrink
                    feature-avatar.mr-4(
                      :size="100 / $goldenRatio"
                      v-shared-element:heroId="{ includeChildren: true, ignoreTransparency: true }"
                      :lazy-src="$get(randomUser, `image.srcLazy`)"
                      :src="$get(randomUser, `image.src`)")
                  v-col.text-truncate(style="font-size: 22px") {{ $get(randomUser, `name`, '\xa0') }}
          v-col.text-center.pt-0(:cols="12")
            v-btn.elevation-2(
              @click="$createOnClick({ onClickRandomUser: trigger })"
              :ripple="false"
              :disabled="loading"
              fab
              small)
              v-icon {{ mdiRefresh }}
</template>

<script>
import { page } from '@iez/core'
import { mdiRefresh } from '@mdi/js'
import UtilityActionState from '@iez/components/utility/action-state/'
import data from '@iez/lib/data/'
import { ref } from '@vue/composition-api'
import waitFor from '@iez/lib/wait-for/'
import user from '@iez/lib/user/'

export default {
  components: {
    UtilityActionState
  },

  setup () {

    page.topBar.set({
      search: true,
      root: true
    })

    const seed = ref(Math.random())
    const lastUserId = ref(null)

    const randomUser = data.get({
      root: `users`,
      random: true,
      one: true,
      fetchPolicy: `network-only`,
      fields: [
        `id`,
        `name`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ],
      request: () => ({
        args: {
          seed: `${seed.value}`
        },
        where: {
          _and: {
            id: {
              _nin: [lastUserId.value, user.id].filter(Boolean)
            },
            name: {
              _is_null: false
            }
          }
        }
      })
    })

    const changeRandomUser = () => {
      seed.value = Math.random()
      lastUserId.value = randomUser.value.id
      randomUser.value = null

      return waitFor({
        dependencies: () => randomUser.value
      })
    }

    return {
      changeRandomUser,
      mdiRefresh,
      randomUser
    }
  }
}
</script>
